import { FixedSizeList } from 'react-window';
import { useRef, useEffect } from 'react';
import { useDeviceType } from '@vfit/shared/hooks';
import { SuggestionItem } from './flatList.style';

const getItemKey = (index: number, data: any) => data.items ? data.items[index] : data[index];

const Flatlist: React.FC<{
  onSelect: (element: string) => void;
  items: string[];
  itemCount: number;
  highlightedIndex?: number;
}> = ({ onSelect, items, itemCount, highlightedIndex = -1 }) => {
  const { isMobile } = useDeviceType();
  const listRef = useRef<FixedSizeList>(null);

  useEffect(() => {
    if (highlightedIndex >= 0 && listRef.current) {
      listRef.current.scrollToItem(highlightedIndex, 'auto');
    }
  }, [highlightedIndex]);

  return (
    <FixedSizeList
      ref={listRef}
      height={itemCount > 3 ? 120 : itemCount * 40}
      itemSize={40}
      itemCount={itemCount}
      width="auto"
      itemData={{ items, highlightedIndex }}
      itemKey={getItemKey}
    >
      {({ index, data, style }) => {
        const item = data.items ? data.items[index] : data[index];
        const isHighlighted = data.highlightedIndex === index;
        return (
          <SuggestionItem
            data-cs-mask=""
            style={style}
            data-highlighted={isHighlighted}
            onClick={(event) => {
              if (!isMobile) event.preventDefault();
              else onSelect(item);
            }}
            onPointerDown={(event) => {
              if (isMobile) event.preventDefault();
              else onSelect(item);
            }}
          >
            {item}
          </SuggestionItem>
        );
      }}
    </FixedSizeList>
  );
};

export default Flatlist;
